import moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'
import { createDisplayName, isUserModerator } from '../../misc/auth-utils'
import { isOdd } from '../../misc/utils'
import { likeComment, unlikeComment } from '../../store/actions/like-comment'
import IconButtonLabel from './icon-button-label'
import { deleteComment } from '../../store/actions/comments'
import IconButton from './icon-button'
import { confirmationDialog } from './confirmation-dialog'

class CommentView extends React.Component {
    onLikeComment = () => {
        if (this.props.comment.liked_by_user)
            this.props.unlikeComment(this.props.idea_id, this.props.comment._id)
        else
            this.props.likeComment(this.props.idea_id, this.props.comment._id)
    }

    onDeleteComment = () => {

        confirmationDialog({
            title: 'Delete Comment',
            text: "Are you sure you want to delete your comment?",
            positiveText: 'Delete',
            positiveColor: 'danger',
            negativeText: 'Cancel',
            negativeColor: 'secondary',

            positiveCallback: () => {
                this.props.deleteComment(this.props.idea_id, this.props.comment._id)
            },
        })     

    }

    render() {
        var submittedMoment = moment(this.props.comment.submitted_at)

        const backgroundColor = isOdd(this.props.index)
            ? 'transparent'
            : 'var(--secondary-very-light)'
        const borderColor = isOdd(this.props.index)
            ? 'var(--secondary-very-light)'
            : 'var(--light-gray)'

        return (
            <div
                className="row align-items-center justify-text-left comment-view"
                style={{
                    backgroundColor: backgroundColor,
                    borderLeft: 'solid 2px',
                    borderLeftColor: borderColor,
                }}>
                {/* DATE, SUBMITTER */}
                <div className="col-md-10 col-lg-6 mr-auto ">
                    <h6 className="mb-2">
                        {createDisplayName(this.props.comment.publisher)}{' '}
                        <small
                            rel="tooltip"
                            title={submittedMoment.format('LLLL')}>
                            commented {submittedMoment.fromNow()}.
                        </small>
                    </h6>
                    <p>{this.props.comment.text}</p>
                </div>

                {(isUserModerator(this.props.auth.user) ||
                    this.props.auth.user._id ===
                        this.props.comment.publisher._id) && (
                    <div className="col-sm-1 text-secondary">
                        <IconButton
                            icon="trash"
                            onClick={this.onDeleteComment}
                        />
                    </div>
                )}
                {/* VOTES */}
                <div className="col-sm-1 text-secondary">
                    <IconButtonLabel
                        text={this.props.comment.like_count}
                        icon="thumbs-up"
                        onClick={this.onLikeComment}
                        pressed={this.props.comment.liked_by_user}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
})

export default connect(mapStateToProps, {
    likeComment,
    unlikeComment,
    deleteComment,
})(CommentView)
